<template>
  <div>
    <filtro @atualizar-grid="atualizaFiltros"></filtro>
    <v-data-table
      class="elevation-5 mb-4 pa-0"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      :headers="headers"
      :items="guias"
      :loading="isLoading"
      :pagination.sync="pagination"
      :total-items="totalProtocolos"
      :rows-per-page-items="pageOptions"
      @update:pagination="atualizaPaginacao"
    >
      <template v-slot:items="props">
        <td>{{ props.item.protocolo }}</td>
        <td>{{ props.item.codigoSolicitacao }}</td>
        <td>{{ props.item.dataSolicitacao }}</td>
        <td>{{ props.item.tipoSolicitacao }}</td>
        <td>{{ props.item.numeroGuia }}</td>
        <td>{{ props.item.descricaoSituacao }}</td>
        <td>
          <v-btn flat small class="green--text" @click="detalhar(props.item)"
            >DETALHAR</v-btn
          >
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { buscaGuiasGrid } from "./service";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

import Filtro from "./filtro";

export default {
  name: "GuiaGrid",
  components: {
    Filtro
  },
  data() {
    return {
      filtro: {},
      guias: [],
      headers: [
        { text: "Protocolo", value: "protocolo", sortable: false },
        { text: "Solicitação", value: "codigoSolicitacao", sortable: false },
        { text: "Data solicitação", value: "dataSolicitacao", sortable: false },
        {
          text: "Tipo de solicitação",
          value: "tipoSolicitacao",
          sortable: false
        },
        { text: "Guia", value: "numeroGuia", sortable: false },
        { text: "Situação", value: "descricaoSituacao", sortable: false }
      ],
      isLoading: false,
      pageOptions: [5, 10, 25, 35],
      pagination: {},
      totalProtocolos: 0
    };
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapGetters(["getFiltro", "getPaginacao"]),
    codigoBeneficiario() {
      return this.dadosBeneficiario.id;
    },
    numeroCartao() {
      return this.dadosBeneficiario.numeroCartao;
    },
    cpf() {
      return this.dadosBeneficiario.cpf;
    }
  },
  watch: {
    codigoBeneficiario: {
      async handler() {
        await this.gridGuias();
      }
    }
  },
  created() {
    this.pagination = this.getPaginacao;
  },
  methods: {
    ...portalStore.mapMutations([
      "setErrorToast",
      "setFiltro",
      "setPaginacao",
      "setToast"
    ]),
    atualizaFiltros(filtro) {
      this.setFiltro(filtro);

      this.gridGuias();
    },
    atualizaPaginacao() {
      this.setPaginacao(this.pagination);

      this.gridGuias();
    },
    detalhar(item) {
      this.$emit("detalhar", item);
    },
    gridGuias() {
      this.isLoading = true;

      const { page, rowsPerPage } = this.getPaginacao;
      const { numeroGuia } = this.getFiltro;

      const payload = {
        codigoBeneficiario: this.numeroCartao.replace(/\D/g, ""),
        numeroGuia,
        pagina: page - 1,
        size: rowsPerPage
      };

      buscaGuiasGrid(payload)
        .then(({ data }) => data)
        .then(({ content, totalElements }) => {
          this.guias = content;
          this.totalProtocolos = totalElements;
        })
        .catch(({ response }) => {
          if (response?.data?.error) {
            const errorMessage = response?.data?.message;

            this.setToast(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
